'use es6';

import { startInpage } from './start';
startInpage();